import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';

interface ProgressDashesProps {
  currentStep: number;
  totalSteps: number;
}

const ProgressDashes = ({ currentStep, totalSteps }: ProgressDashesProps) => {
  const [animatingDash, setAnimatingDash] = useState(currentStep);

  useEffect(() => {
    // Reset animation when current step changes
    setAnimatingDash(currentStep);
  }, [currentStep]);

  return (
    <div className="absolute top-8 left-0 right-0 flex justify-center gap-1">
      {Array.from({ length: totalSteps }).map((_, i) => (
        <div
          key={i}
          className="h-1 rounded-sm w-16 bg-gray-300 overflow-hidden"
        >
          {i < currentStep ? (
            // Already filled dashes
            <div className="w-full h-full bg-[#FF9B7B]" />
          ) : i === currentStep ? (
            // Currently animating dash
            <motion.div
              className="w-full h-full bg-[#FF9B7B]"
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 5, ease: "linear" }}
              style={{ originX: 0 }}
            />
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default ProgressDashes;
